<div class="mtn-title">
    <p>VEHICLE SELECT ({{this.fromMainData.table}})</p>
</div>
<osp-table [tblConfig]="dataTableConfig" (onRowClick)="onRowClick($event)"></osp-table>
<div class="btn-grp-2 btn-grp-2-l">
    <button class="btn btn2" type="button" (click)="onClose('OK')">OK</button>
    <button class="btn btn4" type="button" (click)="onClose('BACK')">BACK</button>
</div>